import { Component, OnInit,ViewChild,ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource,MatTable } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogConfig } from '@angular/material/dialog';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { GuestPurchaseService } from 'app/shared/services/guest-purchase.service';
import { NbThemeService } from '@nebular/theme';
import { GuestPurchaseComponent } from '../guest-purchase/guest-purchase.component';
import { animate, state, style, transition, trigger } from '@angular/animations';



@Component({
  selector: 'ngx-guest-purchase-list',
  templateUrl: './guest-purchase-list.component.html',
  styleUrls: ['./guest-purchase-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class GuestPurchaseListComponent implements OnInit {

  isTableExpanded = false;


  displayedColumns: string[] =  ['GuestId', 'GuestName', 'TotalAmount','Action'];
  innerDisplayedColumns = ['PurchaseDate','ItemCode', 'Description', 'UnitPrice','Qty','Amount','Status','CreatedBy','Action'];
  expandedElement: any | null;

 // @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;

  dataSource :MatTableDataSource<any>
  guestPurshaseData: any[] = [];

  searchKey : string;
  isDark: boolean = false;

  dataList : any;  
  filteredList = [];


  constructor(
              private guestPurchaseService : GuestPurchaseService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private companyProfileService: CompanyProfileService,
              private themeService: NbThemeService,
              private cd: ChangeDetectorRef,
             ) { }
                  
             

  ngOnInit(): void {

    this.getPurchaseList();
  

      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
          });
  }


  newButtonClick(){
   const dialogConfig = new MatDialogConfig();
   dialogConfig.disableClose = true;
   dialogConfig.autoFocus = true;
   dialogConfig.width = "50%";
   this.dialogService.openDialog(GuestPurchaseComponent,dialogConfig)
   .afterClosed().subscribe(res => this.getPurchaseList());  
  }

  veiwButtonClick(row){
    const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.data = row;
     dialogConfig.width = "50%";
     this.dialogService.openDialog(GuestPurchaseComponent,dialogConfig)
      .afterClosed().subscribe(res => {});

  }

  toggleRow(element:any) {
     element.purchaseItems && (element.purchaseItems as MatTableDataSource<any>).data.length ? (this.expandedElement = this.expandedElement === element ? null : element) : null;
   //this.cd.detectChanges();
   //this.innerTables.forEach((table, index) => (table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index]);

  }




  getPurchaseList(){
    this.guestPurshaseData = [];
    this.guestPurchaseService.getAll()
     .subscribe(
        (data) => {
                  this.dataList = data;              
                 this.dataList.forEach(data => {
                  if (data.purchaseItems && Array.isArray(data.purchaseItems) && data.purchaseItems.length) {
                    this.guestPurshaseData = [...this.guestPurshaseData, {...data, purchaseItems: new MatTableDataSource(data.purchaseItems)}];
                  } else {
                    this.guestPurshaseData = [...this.guestPurshaseData, data];
                  }
                });

                this.dataSource = new MatTableDataSource(this.guestPurshaseData);
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
              
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                }); 
      
     }


    deleteButtonClick(id : number){
      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.guestPurchaseService.delete(id)
        .subscribe(
          (res) => {
                      this.toastr.success('User was deleted successfully','Success');
                      this.getPurchaseList();
                      console.log(res);     
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete user','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
  }

  applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

  }

  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }




}//end class
